'use client';

import { cn } from '@bells/core/lib/utils';
import { faqButtonBackButton } from '@bells/i18n';
import { FaqResponse, SingleFaqResponse } from '@bells/schema/models/faq';
import { Button } from '@bells/ui/components/button';
import { ChevronLeft } from 'lucide-react';
import Link from 'next/link';
import { useEffect, useRef } from 'react';

export default function HelpSidebar({
  thread,
  topicUrl,
  topics,
}: {
  thread: SingleFaqResponse;
  topicUrl: string;
  topics: FaqResponse[];
}) {
  const ref = useRef<HTMLDivElement>(null);
  const activeRef = useRef<HTMLAnchorElement>(null);

  useEffect(() => {
    if (activeRef.current) {
      const top = activeRef.current.offsetTop;
      ref.current?.scrollTo({ top: top });
    }
  }, [activeRef.current]);

  return (
    <div className='hidden h-full flex-col items-start border-r py-4 md:flex md:py-8 md:pr-8'>
      <Button size={'lg'} asChild className='mb-6 w-full'>
        <Link href={topicUrl}>
          <ChevronLeft></ChevronLeft>
          <span>{faqButtonBackButton()}</span>
        </Link>
      </Button>
      <div className='relative flex-1'>
        <div
          ref={ref}
          className='flex h-full w-full flex-col gap-4 overflow-auto'
        >
          {topics.map((df, index) => {
            return (
              <Link
                key={`topic-${index}`}
                className={cn(
                  'truncate text-ellipsis border-b py-2 text-[14px] shadow-sm last:border-none hover:underline',
                  {
                    'font-bold': df.slug === thread.slug,
                  }
                )}
                ref={df.slug === thread.slug ? activeRef : null}
                href={`${topicUrl}/${df.slug}`}
              >
                {df.title}
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
}
